import React from "react";
import {Col, Row} from "react-bootstrap";
import {ReactSVG} from "react-svg";
import iconCheckBox from "@Icons/SVG/icon-check_box.svg";
import SectionContainerComponent from "../../../@Components/Sections/SectionContainer";

import sectionImage from "./@Images/sectionImage.svg";
import robotImage from "./../@@Images/robotImage.svg";


export const HomePageRecoveryEngineSection:React.FC = () => {

    return (
        <SectionContainerComponent id={'home-page__care-section'}>

            <Col xs={12} xl={6} className={'home-page__care-section__information'}>
                <Row className={'home-page__care-section__information__content'}>
                    <Col xs={12} className={'home-page__care-section__information__header'}>
                            <span>
                                Meet Qyvo's Customer Automated Recovery Engine - C.A.R.E.
                            </span>
                    </Col>
                    <Col xs={12} className={'home-page__care-section__information__description'}>
                            <span>
                                C.A.R.E never sleeps, never forgets and never misses a refund opportunity. It works 24/7 to scan your inbox and identify money you're owed.
                            </span>
                    </Col>
                    <Col xs={12} className={'home-page__care-section__information__elements-list'}>
                        <ul className={'home-page__care-section__information__elements-list__list'}>
                            <li className={'home-page__care-section__information__elements-list__list__element'}>
                                <ReactSVG src={iconCheckBox} wrapper={'span'} className={'element-icon'} />
                                <span className={'element-text'}>Scans 100% of your email history</span>
                            </li>
                            <li className={'home-page__care-section__information__elements-list__list__element'}>
                                <ReactSVG src={iconCheckBox} wrapper={'span'} className={'element-icon'} />
                                <span className={'element-text'}>Spots every refundable opportunity</span>
                            </li>
                            <li className={'home-page__care-section__information__elements-list__list__element'}>
                                <ReactSVG src={iconCheckBox} wrapper={'span'} className={'element-icon'} />
                                <span className={'element-text'}>Identifies complex refund patterns</span>
                            </li>
                            <li className={'home-page__care-section__information__elements-list__list__element'}>
                                <ReactSVG src={iconCheckBox} wrapper={'span'} className={'element-icon'} />
                                <span className={'element-text'}>Files and tracks claims automatically</span>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Col>

            <Col xs={12} xl={6} className={'home-page__care-section__cta'}>
                <Row className={'home-page__care-section__cta__content'}>
                    <img src={robotImage} alt={''} />
                </Row>
            </Col>

        </SectionContainerComponent>
    );

};


export default HomePageRecoveryEngineSection;
